import Column from '@app/components/layout/Column'
import { FollowedHousingForms } from './FollowedHousingForms'
import { FollowedInitiatives } from './FollowedInitiatives'
import { FollowedPlots } from './FollowedPlots'
import { FollowedRegions } from './FollowedRegions'

export const FollowingTab = () => {
  return (
    <Column alignItems="stretch" gap="2rem">
      <FollowedInitiatives />
      <FollowedPlots />
      <FollowedRegions />
      <FollowedHousingForms />
    </Column>
  )
}
